import { Request } from "shared/src/services/Requests";
const RequestBuilder = new Request.Builder("cia", "customerhistory");

const service = {
    getAllCustomerHistoryByTemplateTypes(country: string, customerId: string, templateTypes: string[]) {
        const template = "/customer-history/{country}/{customerId}";
        const pathParams = {
            country,
            customerId
        };

        return RequestBuilder.path(template, pathParams).query({ templateType: templateTypes }).get();
    }
};

export default service;
